import React from "react";

const DefaultTitle = ({ title }) => {
    return <h1 className="default-title">{title}</h1>;
};

export default DefaultTitle;
